'use client';
import { useAppPathname, useAppSearchParams } from '../../shared/router/AppRouterContext';
import { DialogTitle } from '@vs-shop/ui/dialog';
import { useIntl } from 'react-intl';

import { callbackUrlQueryParam, isAllowedCallbackUrl } from '../../config/callbarkUrl';
import { Url } from '../../route/router';

import { navigateFullPage, reloadPage } from '../../utils/router';

import LoginForm from './LoginForm';

import { authModalAtom, AuthModalMode } from '@vs-shop/engine/atom/ui/authModal';
import { useAtomSet } from '@effect/atom-react';

type Props = {
  shouldStayAtTheSamePageAfterLogin: boolean;
};

export default function LoginModalContent({ shouldStayAtTheSamePageAfterLogin }: Props) {
  const intl = useIntl();
  const setAuthModal = useAtomSet(authModalAtom);

  const currentPathname = useAppPathname();
  const searchParams = useAppSearchParams();
  const encodedParams = searchParams.toString();
  const callbackUrlParam = searchParams.get(callbackUrlQueryParam);

  const shouldStayAtTheSamePageLocal =
    shouldStayAtTheSamePageAfterLogin || currentPathname === Url.cart;

  const isCallbackUrlAllowed = callbackUrlParam !== null && isAllowedCallbackUrl(callbackUrlParam);
  const callbackUrl = isCallbackUrlAllowed ? callbackUrlParam : Url.accountDashboard;

  const switchToRegisterUrl = `${Url.registration}${encodedParams ? `?${encodedParams}` : ''}`;

  return (
    <div className="p-6">
      {/* Modal Header */}
      <div className="mb-6 flex">
        <DialogTitle className="text-lg leading-normal font-normal">
          {intl.formatMessage({
            id: 'component.authModal.login.heading',
            defaultMessage: 'Přihlášení',
          })}
        </DialogTitle>
      </div>

      {/* Login Form */}
      <LoginForm
        onSuccessAction={() => {
          setAuthModal((prev) => ({ ...prev, isOpen: false }));
          if (shouldStayAtTheSamePageLocal) {
            reloadPage();
            return;
          }
          navigateFullPage(callbackUrl);
        }}
        onSwitchToRegisterAction={() => {
          setAuthModal((prev) => ({ ...prev, isOpen: false }));
          navigateFullPage(switchToRegisterUrl);
        }}
        onSwitchToResetPasswordAction={() => {
          setAuthModal((prev) => ({ ...prev, mode: AuthModalMode.resetPassword }));
        }}
      />
    </div>
  );
}
